import generateId from '@com/utils/generate-id'
import gameIframe from '@ps/bridge/iframe/iframe'
import { getParkNode } from '@ps/bridge/qc/base'
import { scripts } from '@ps/bridge/qc/scripts'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import { nodeTypes } from '@ps/bridge/qc/scripts/editor'
import { EventBus, Event } from '@ps/utils/event-bus'
import {
  ImageType,
  RoadRule,
  MoveDir,
  makeRoadAreaResData,
  ElementType,
  makeCustomEle,
  getEmptyFilters,
  makeRoadImageData,
  makeRoadAreaData,
  BackType,
  transform2bin,
} from '@ps/workbench/undo-redo/module/park'
import _ from 'lodash'
import { Message } from 'element-ui'
import i18n from '@ps/lang'

const getInitState = () => {
  return {
    newGuideStep: 0,
    dialog: {
      visible: false,
      appendToBody: true,
      modal: true,
      width: '800px',
      top: '88px',
      uuid: '',
      onReplaced: () => {},
    },
    bgSettingDialog: {
      visible: false,
      appendToBody: true,
      modal: false,
      width: '320px',
      top: '128px',
      right: 'calc(648px - 100vw)',
    },
    moveDirSettingDialog: {
      visible: false,
      appendToBody: true,
      modal: false,
      width: '320px',
      top: '128px',
      right: 'calc(648px - 100vw)',
      moveDir: null,
    },
    elementResSettingDialog: {
      visible: false,
      appendToBody: true,
      modal: false,
      width: '320px',
      top: '128px',
      right: 'calc(648px - 100vw)',
    },
    addGroupDialog: {
      visible: false,
      appendToBody: true,
      modal: false,
      width: '340px',
      top: '128px',
      right: 'calc(668px - 100vw)',
    },
    customSettingDialog: {
      visible: false,
      appendToBody: true,
      modal: false,
      width: '312px',
      top: '128px',
      right: 'calc(640px - 100vw)',
    },
    addExitGroupDialog: {
      visible: false,
      appendToBody: true,
      modal: false,
      width: '340px',
      top: '128px',
      right: 'calc(668px - 100vw)',
    },
    historyList: [],
    undoList: [],
    sceneNode: null, // 打开编辑面板对应的场景节点
    step: 1,
    isGridDrag: false, // 是否拖拽
    isSelectTool: false, // 选择工具选中
    isEraseTool: false, // 擦除工具选中
    scale: 1, // 编辑画布区缩放大小
    step1MapDataBackup: null, // 第1步的备份地图数据
    step2MapDataBackup: null, // 第2步的备份地图数据
    hoverGrid: null, // 鼠标悬浮的格子
    mapData: {
      grid: {
        row: 8,
        column: 8,
        size: 40,
      },
      bg: null,
      roadRule: RoadRule.EleOnRoad, // 道路放置规则
      roadImages: [], // 道路图片
      isRoadArea: false, // 道路是否选择区域
      moveDirEnable: true, // 运动方向启用
      moveDirVisible: true, // 运动方向显示
      moveDirImages: {
        // 运动方向图片
        [MoveDir.Forward]: null,
        [MoveDir.TurnLeft]: null,
        [MoveDir.TurnRight]: null,
        [MoveDir.Left]: null,
        [MoveDir.Right]: null,
      },
      mainEleEnable: true, // 主元素启用
      mainEles: [], // 主元素列表
      obsEleEnable: true, // 障碍元素启用
      obsEles: [], // 障碍元素列表
      customEles: [], // 自定义元素列表
      exitEles: [], // 出口的数据
      editingElementType: null, // 第二步正在编辑弹窗的元素类型
      editingCustomEleId: null, // 第二步自定义元素正在添加分类的大类id
      editingResource: null, // 第二步正在编辑的资源
      resourceSelected: null, // 选中的资源
      editingElementGrid: null, // 第二步正在编辑的格子主元素
      renderData: [], // 渲染的格子地图数据
      selectedGrid: null, // 选中的格子
      moveGrid: null, // 记录当前移动格子里的物品
      movePosition: null, // 记录正在移动的格子的坐标
    },
  }
}

export default {
  namespaced: true,

  state: getInitState(),

  getters: {},

  mutations: {
    updateNewGuideStep(state, value) {
      state.newGuideStep = value
    },
    openDialog(state) {
      state.dialog.visible = true
      this.dispatch('workspace/park/readRenderMapDataFromScript')
      // 打开弹窗时重置平台的初始值
      state.step = 1
      state.isGridDrag = false
      state.isSelectTool = false
      state.isEraseTool = false
      state.scale = 1
      state.step1MapDataBackup = null
      state.step2MapDataBackup = null
      state.moveDirSettingDialog.moveDir = null
      state.mapData.editingElementType = null
      state.mapData.editingCustomEleId = null
      state.mapData.editingResource = null
      state.mapData.resourceSelected = null
      state.mapData.editingElementGrid = null
      state.mapData.selectedGrid = null
      state.hoverGrid = null
      state.mapData.moveGrid = null
      state.mapData.movePosition = null
    },
    closeDialog(state) {
      state.dialog.visible = false
    },
    openBgSettingDialog(state) {
      state.bgSettingDialog.visible = true
    },
    closeBgSettingDialog(state) {
      state.bgSettingDialog.visible = false
    },
    openMoveDirSettingDialog(state) {
      state.moveDirSettingDialog.visible = true
    },
    closeMoveDirSettingDialog(state) {
      state.moveDirSettingDialog.visible = false
    },
    openElementResSettingDialog(state) {
      state.elementResSettingDialog.visible = true
    },
    closeElementResSettingDialog(state) {
      state.elementResSettingDialog.visible = false
    },
    updateEditingResource(state, info) {
      state.mapData.editingResource = info
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    openAddGroupDialog(state) {
      state.addGroupDialog.visible = true
    },
    closeAddGroupDialog(state) {
      state.addGroupDialog.visible = false
    },
    openAddExitGroupDialog(state) {
      state.addExitGroupDialog.visible = true
    },
    closeAddExitGroupDialog(state) {
      state.addExitGroupDialog.visible = false
    },
    openCustomSettingDialog(state) {
      state.customSettingDialog.visible = true
    },
    closeCustomSettingDialog(state) {
      state.customSettingDialog.visible = false
    },
    updateSceneNode(state, value) {
      state.sceneNode = value
    },
    updateScale(state, value) {
      state.scale = value
    },
    updateIsEraseTool(state, value) {
      state.isEraseTool = value
    },
    updateIsSelectTool(state, value) {
      state.isSelectTool = value
    },
    updateSelectedGrid(state, value) {
      if (value) {
        state.mapData.selectedGrid = value
        state.mapData = _.cloneDeep(state.mapData)
        this.dispatch('workspace/park/addHistory', state.mapData)
      } else {
        state.mapData.selectedGrid = value
      }
    },
    updateHoverGrid(state, value) {
      state.hoverGrid = value
    },
    updateStep(state, value) {
      state.step = value
      state.isGridDrag = false
      state.isSelectTool = false
      state.isEraseTool = false
      state.moveDirSettingDialog.moveDir = null
      state.mapData.editingElementType = null
      state.mapData.editingCustomEleId = null
      state.mapData.editingResource = null
      state.mapData.resourceSelected = null
      state.mapData.editingElementGrid = null
      state.moveDirSettingDialog.visible = false
      state.elementResSettingDialog.visible = false
      state.addGroupDialog.visible = false
      state.addExitGroupDialog.visible = false
      state.customSettingDialog.visible = false
      state.mapData.selectedGrid = null
      state.hoverGrid = null
      state.mapData.moveGrid = null
      state.mapData.movePosition = null
    },
    updateStep1MapDataBackup(state) {
      state.step1MapDataBackup = _.cloneDeep(state.mapData)
    },
    updateStep2MapDataBackup(state) {
      state.step2MapDataBackup = _.cloneDeep(state.mapData)
    },
    recoverStep1MapData(state) {
      state.mapData = _.cloneDeep(state.step1MapDataBackup)
    },
    recoverStep2MapData(state) {
      state.mapData = _.cloneDeep(state.step2MapDataBackup)
    },
    updateMapData(state, value) {
      state.mapData = value
    },
    updateMapDataHistory(state) {
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateRow(state, value) {
      state.mapData.grid.row = value
      this.dispatch('workspace/park/clearRenderMapData')
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateColumn(state, value) {
      state.mapData.grid.column = value
      this.dispatch('workspace/park/clearRenderMapData')
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateSize(state, value) {
      state.mapData.grid.size = value
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateBg(state, value) {
      if (value) {
        if (!state.mapData.bg) {
          state.mapData.bg = {}
        }
        state.mapData.bg = Object.assign(state.mapData.bg, value)
      } else {
        state.mapData.bg = value
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateBgProps(state, data) {
      state.mapData.bg = Object.assign(state.mapData.bg, data)
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateIsRoadArea(state, value) {
      state.mapData.isRoadArea = value
      if (!value) {
        state.mapData.renderData.forEach((rowItem) => {
          rowItem.forEach((item) => {
            if (item.road && item.road.resID === ImageType.AREA) {
              delete item.isRoad
              delete item.road
            }
          })
        })
        if (
          state.mapData.resourceSelected &&
          ImageType.AREA === state.mapData.resourceSelected.id
        ) {
          state.mapData.resourceSelected = null
        }
        state.isSelectTool = false
      } else {
        state.isSelectTool = true
        state.isEraseTool = false
        state.mapData.resourceSelected = makeRoadAreaResData()
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateRoadRule(state, value) {
      state.mapData.roadRule = value
      // 改变道路规则需要清掉元素和出口
      for (let i = 0; i < state.mapData.grid.row; i++) {
        for (let j = 0; j < state.mapData.grid.column; j++) {
          delete state.mapData.renderData[i][j].element
          delete state.mapData.renderData[i][j].exit
        }
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    addRoadImages(state, value) {
      state.mapData.roadImages.push(value)
      if (!state.mapData.resourceSelected) {
        state.mapData.resourceSelected = _.cloneDeep(value)
        state.isSelectTool = true
        state.isEraseTool = false
      }
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    deleteRoadImage(state, id) {
      state.mapData.roadImages = state.mapData.roadImages.filter(
        (item) => item.id !== id,
      )
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.road && item.road.resID === id) {
            delete item.isRoad
            delete item.road
          }
        })
      })
      state.mapData.selectedGrid = null
      if (
        state.mapData.resourceSelected &&
        id === state.mapData.resourceSelected.id
      ) {
        state.mapData.resourceSelected = null
        state.isSelectTool = false
      }
      if (state.mapData.roadImages.length === 0) {
        state.mapData.resourceSelected = null
        state.isSelectTool = false
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateRoadImage(state, data) {
      const index = state.mapData.roadImages.findIndex(
        (item) => item.id === data.id,
      )
      state.mapData.roadImages[index] = Object.assign(
        state.mapData.roadImages[index],
        data,
      )
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.road && item.road.resID === data.id) {
            item.road.url = data.url
            item.road.resourceUrl = transform2bin(data.url)
          }
        })
      })
      if (
        state.mapData.resourceSelected &&
        data.id === state.mapData.resourceSelected.id
      ) {
        state.mapData.resourceSelected = state.mapData.roadImages[index]
        state.isSelectTool = true
        state.isEraseTool = false
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    toggleVisibleRoadImage(state, id) {
      const index = state.mapData.roadImages.findIndex((item) => item.id === id)
      const visible = state.mapData.roadImages[index].visible
      state.mapData.roadImages[index].visible = !visible
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.road && item.road.resID === id) {
            item.road.visible = !visible
          }
        })
      })
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateResourceSelected(state, resource) {
      if (resource) {
        state.mapData.resourceSelected = _.cloneDeep(resource)
        state.isSelectTool = true
        state.isEraseTool = false
        state.mapData = _.cloneDeep(state.mapData)
        this.dispatch('workspace/park/addHistory', state.mapData)
      } else {
        state.mapData.resourceSelected = null
      }
    },
    updateIsGridDrag(state, value) {
      state.isGridDrag = value
    },
    updateRoadImageRotation(state, data) {
      const gridInfo = state.mapData.renderData[data.rowIndex][data.columnIndex]
      if (gridInfo.road) {
        gridInfo.road.rotation += data.rotation
        if (gridInfo.road.rotation === 360 || gridInfo.road.rotation === -360) {
          gridInfo.road.rotation = 0
        }
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateElementRotation(state, data) {
      const gridInfo = state.mapData.renderData[data.rowIndex][data.columnIndex]
      if (gridInfo.element) {
        gridInfo.element.rotation += data.rotation
        if (
          gridInfo.element.rotation === 360 ||
          gridInfo.element.rotation === -360
        ) {
          gridInfo.element.rotation = 0
        }
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    deleteRoad(state, data) {
      const gridInfo = state.mapData.renderData[data.rowIndex][data.columnIndex]
      if (gridInfo.road) {
        delete gridInfo.road
        delete gridInfo.isRoad
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    deleteElement(state, data) {
      const gridInfo = state.mapData.renderData[data.rowIndex][data.columnIndex]
      if (gridInfo.element) {
        delete gridInfo.element
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateMoveDirEnable(state, value) {
      state.mapData.moveDirEnable = value
      // 禁用运动方向时，把所有格子的运动方向设置为直行
      if (!value) {
        state.mapData.renderData.forEach((rowItem) => {
          rowItem.forEach((item) => {
            if (item.element) {
              item.element.moveDir = MoveDir.Forward
              item.element.moveDirVisible = false
            }
          })
        })
      }
      state.mapData.moveDirVisible = value
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateMoveDirVisible(state, value) {
      state.mapData.moveDirVisible = value
      // rendermap的数据联动改动
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.element) {
            item.element.moveDirVisible = value
          }
        })
      })
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    addMoveDirImage(state, value) {
      state.mapData.moveDirImages[value.imageName] = value
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateMoveDirImage(state, data) {
      state.mapData.moveDirImages[data.imageName] = Object.assign(
        state.mapData.moveDirImages[data.imageName],
        data,
      )
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateEditingMoveDir(state, value) {
      state.moveDirSettingDialog.moveDir = value
    },
    updateMoveDirImageProps(state, data) {
      state.mapData.moveDirImages[data.moveDir] = Object.assign(
        state.mapData.moveDirImages[data.moveDir],
        data.data,
      )
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    applyToAllMoveDir(state, moveDir) {
      const scaleX = state.mapData.moveDirImages[moveDir].scaleX
      const scaleY = state.mapData.moveDirImages[moveDir].scaleY
      for (const i in state.mapData.moveDirImages) {
        if (state.mapData.moveDirImages[i]) {
          state.mapData.moveDirImages[i].scaleX = scaleX
          state.mapData.moveDirImages[i].scaleY = scaleY
        }
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateEditingElementType(state, value) {
      state.mapData.editingElementType = value
      state.mapData = _.cloneDeep(state.mapData)
    },
    updateEditingCustomEleId(state, id) {
      state.mapData.editingCustomEleId = id
      state.mapData = _.cloneDeep(state.mapData)
    },
    addMainEleCategory(state, value) {
      state.mapData.mainEles.push(value)
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    addObsEleCategory(state, value) {
      state.mapData.obsEles.push(value)
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    addMainEleResource(state, data) {
      const mainEle = state.mapData.mainEles.find(
        (item) => item.id === data.categoryId,
      )
      mainEle.resource.push(data.data)
      if (!state.mapData.resourceSelected) {
        state.mapData.resourceSelected = _.cloneDeep(data.data)
        state.isSelectTool = true
        state.isEraseTool = false
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    deleteMainEleCategory(state, id) {
      const index = state.mapData.mainEles.findIndex((item) => item.id === id)
      const resIdList = state.mapData.mainEles[index].resource.map(
        (item) => item.id,
      )
      // 格子数据联动
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.element && resIdList.indexOf(item.element.resID) > -1) {
            delete item.element
          }
        })
      })
      state.mapData.mainEles.splice(index, 1)
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    deleteMainEleRes(state, id) {
      for (const i in state.mapData.mainEles) {
        const index = state.mapData.mainEles[i].resource.findIndex(
          (item) => item.id === id,
        )
        if (index > -1) {
          state.mapData.mainEles[i].resource.splice(index, 1)
        }
      }
      // 格子里的数据联动
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.element && item.element.resID === id) {
            delete item.element
          }
        })
      })
      state.mapData.selectedGrid = null
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateMainEleRes(state, data) {
      for (const i in state.mapData.mainEles) {
        const index = state.mapData.mainEles[i].resource.findIndex(
          (item) => item.id === data.id,
        )
        if (index > -1) {
          data.ext = {}
          data.ext.filters = getEmptyFilters()
          data.ext.oriResource = [data.url]
          state.mapData.mainEles[i].resource[index] = Object.assign(
            state.mapData.mainEles[i].resource[index],
            data,
          )
        }
      }
      // 格子里的数据联动
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.element && item.element.resID === data.id) {
            item.element.url = data.url
            item.element.resourceUrl = transform2bin(data.url)
          }
        })
      })
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    copyMainEleRes(state, id) {
      for (const i in state.mapData.mainEles) {
        const index = state.mapData.mainEles[i].resource.findIndex(
          (item) => item.id === id,
        )
        if (index > -1) {
          const res = _.cloneDeep(state.mapData.mainEles[i].resource[index])
          res.id = generateId()
          res.imageName += '_Copy'
          state.mapData.mainEles[i].resource.push(res)
          state.mapData = _.cloneDeep(state.mapData)
          this.dispatch('workspace/park/addHistory', state.mapData)
        }
      }
    },
    // 障碍类
    addObsEleResource(state, data) {
      const obsEle = state.mapData.obsEles.find(
        (item) => item.id === data.categoryId,
      )
      obsEle.resource.push(data.data)
      if (!state.mapData.resourceSelected) {
        state.mapData.resourceSelected = _.cloneDeep(data.data)
        state.isSelectTool = true
        state.isEraseTool = false
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    deleteObsEleCategory(state, id) {
      const index = state.mapData.obsEles.findIndex((item) => item.id === id)
      const resIdList = state.mapData.obsEles[index].resource.map(
        (item) => item.id,
      )
      // 格子数据联动
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.element && resIdList.indexOf(item.element.resID) > -1) {
            delete item.element
          }
        })
      })
      state.mapData.obsEles.splice(index, 1)
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    deleteObsEleRes(state, id) {
      for (const i in state.mapData.obsEles) {
        const index = state.mapData.obsEles[i].resource.findIndex(
          (item) => item.id === id,
        )
        if (index > -1) {
          state.mapData.obsEles[i].resource.splice(index, 1)
        }
      }
      // 格子里的数据联动
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.element && item.element.resID === id) {
            delete item.element
          }
        })
      })
      state.mapData.selectedGrid = null
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateObsEleRes(state, data) {
      for (const i in state.mapData.obsEles) {
        const index = state.mapData.obsEles[i].resource.findIndex(
          (item) => item.id === data.id,
        )
        if (index > -1) {
          data.ext = {}
          data.ext.filters = getEmptyFilters()
          data.ext.oriResource = [data.url]
          state.mapData.obsEles[i].resource[index] = Object.assign(
            state.mapData.obsEles[i].resource[index],
            data,
          )
        }
      }
      // 格子里的数据联动
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.element && item.element.resID === data.id) {
            item.element.url = data.url
            item.element.resourceUrl = transform2bin(data.url)
          }
        })
      })
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    copyObsEleRes(state, id) {
      for (const i in state.mapData.obsEles) {
        const index = state.mapData.obsEles[i].resource.findIndex(
          (item) => item.id === id,
        )
        if (index > -1) {
          const res = _.cloneDeep(state.mapData.obsEles[i].resource[index])
          res.id = generateId()
          res.imageName += '_Copy'
          state.mapData.obsEles[i].resource.push(res)
          state.mapData = _.cloneDeep(state.mapData)
          this.dispatch('workspace/park/addHistory', state.mapData)
        }
      }
    },

    updateMainEleEnable(state, value) {
      state.mapData.mainEleEnable = value
      // rendermap的数据联动改动
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.element && item.element.elementType === ElementType.Main) {
            delete item.element
          }
        })
      })
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },

    updateObsEleEnable(state, value) {
      state.mapData.obsEleEnable = value
      // rendermap的数据联动改动
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.element && item.element.elementType === ElementType.Obs) {
            delete item.element
          }
        })
      })
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },

    updateEditingElementGrid(state, data) {
      if (data) {
        state.mapData.editingElementGrid = {
          rowIndex: data.rowIndex,
          columnIndex: data.columnIndex,
        }
      } else {
        state.mapData.editingElementGrid = null
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateElementGridMoveDir(state, data) {
      state.mapData.renderData[data.rowIndex][
        data.columnIndex
      ].element.moveDir = data.moveDir
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateElementGridBackType(state, data) {
      state.mapData.renderData[data.rowIndex][
        data.columnIndex
      ].element.backType = data.backType
      // 如果是禁用就所有格子一起禁用
      if (data.backType === BackType.Disabled) {
        state.mapData.renderData.forEach((rowItem) => {
          rowItem.forEach((item) => {
            if (item.element) {
              item.element.backType = BackType.Disabled
            }
          })
        })
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    applyBackTypeToAllGrid(state, value) {
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.element) {
            item.element.backType = value
          }
        })
      })
    },
    // 自定义元素
    addCustomEle(state) {
      const index = state.mapData.customEles.length + 1
      const data = makeCustomEle(index)
      state.mapData.customEles.push(data)
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateCustomEleEnable(state, data) {
      const index = state.mapData.customEles.findIndex(
        (item) => item.id === data.id,
      )
      state.mapData.customEles[index].enable = data.enable
      // 格子数据联动
      if (!data.enable) {
        const resIdList = []
        state.mapData.customEles[index].customCategory.forEach((item) => {
          item.resource.forEach((res) => {
            resIdList.push(res.id)
          })
        })
        // 格子数据联动
        state.mapData.renderData.forEach((rowItem) => {
          rowItem.forEach((item) => {
            if (item.element && resIdList.indexOf(item.element.resID) > -1) {
              delete item.element
            }
          })
        })
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    addCustomEleCategory(state, data) {
      const index = state.mapData.customEles.findIndex(
        (item) => item.id === state.mapData.editingCustomEleId,
      )
      state.mapData.customEles[index].customCategory.push(data)
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    deleteCustomEleCategory(state, data) {
      const index = state.mapData.customEles.findIndex(
        (item) => item.id === data.customCategoryId,
      )
      const subIndex = state.mapData.customEles[index].customCategory.findIndex(
        (item) => item.id === data.categoryId,
      )
      const resIdList = state.mapData.customEles[index].customCategory[
        subIndex
      ].resource.map((item) => item.id)
      // 格子数据联动
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.element && resIdList.indexOf(item.element.resID) > -1) {
            delete item.element
          }
        })
      })
      state.mapData.customEles[index].customCategory.splice(subIndex, 1)
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    addCustomEleResource(state, data) {
      const index = state.mapData.customEles.findIndex(
        (item) => item.id === data.customCategoryId,
      )
      const customEle = state.mapData.customEles[index].customCategory.find(
        (item) => item.id === data.categoryId,
      )
      customEle.resource.push(data.data)
      if (!state.mapData.resourceSelected) {
        state.mapData.resourceSelected = _.cloneDeep(data.data)
        state.isSelectTool = true
        state.isEraseTool = false
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    deleteCustomEleRes(state, data) {
      const customEle = state.mapData.customEles.find(
        (item) => item.id === data.customCategoryId,
      )
      for (const i in customEle.customCategory) {
        const index = customEle.customCategory[i].resource.findIndex(
          (item) => item.id === data.id,
        )
        if (index > -1) {
          customEle.customCategory[i].resource.splice(index, 1)
        }
      }
      // 格子里的数据联动
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.element && item.element.resID === data.id) {
            delete item.element
          }
        })
      })
      state.mapData.selectedGrid = null
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateCustomEleRes(state, data) {
      const customEle = state.mapData.customEles.find(
        (item) => item.id === data.customCategoryId,
      )
      for (const i in customEle.customCategory) {
        const index = customEle.customCategory[i].resource.findIndex(
          (item) => item.id === data.data.id,
        )
        if (index > -1) {
          data.data.ext = {}
          data.data.ext.filters = getEmptyFilters()
          data.data.ext.oriResource = [data.data.url]
          customEle.customCategory[i].resource[index] = Object.assign(
            customEle.customCategory[i].resource[index],
            data.data,
          )
        }
      }
      // 格子里的数据联动
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.element && item.element.resID === data.data.id) {
            item.element.url = data.data.url
            item.element.resourceUrl = transform2bin(data.data.url)
          }
        })
      })
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    copyCustomEleRes(state, data) {
      const customEle = state.mapData.customEles.find(
        (item) => item.id === data.customCategoryId,
      )
      for (const i in customEle.customCategory) {
        const index = customEle.customCategory[i].resource.findIndex(
          (item) => item.id === data.id,
        )
        if (index > -1) {
          const res = _.cloneDeep(customEle.customCategory[i].resource[index])
          res.id = generateId()
          res.imageName += '_Copy'
          customEle.customCategory[i].resource.push(res)
          state.mapData = _.cloneDeep(state.mapData)
          this.dispatch('workspace/park/addHistory', state.mapData)
        }
      }
    },
    renameCustomEle(state, data) {
      const customEle = state.mapData.customEles.find(
        (item) => item.id === data.id,
      )
      customEle.name = data.name
      customEle.nameEn = data.name
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    copyCustomEle(state, id) {
      const customEle = state.mapData.customEles.find((item) => item.id === id)
      const copyCustomEle = _.cloneDeep(customEle)
      copyCustomEle.id = generateId()
      copyCustomEle.name += '_Copy'
      copyCustomEle.nameEn += '_Copy'
      copyCustomEle.customCategory.forEach((item) => {
        item.id = generateId()
        item.resource.forEach((res) => {
          res.id = generateId()
        })
      })
      state.mapData.customEles.push(copyCustomEle)
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    deleteCustomEle(state, id) {
      state.mapData.customEles = state.mapData.customEles.filter(
        (item) => item.id !== id,
      )
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateResourceProps(state, data) {
      console.log(state.mapData.editingResource, data)
      const resource = state.mapData.editingResource
      let targetRes = null
      if (resource.elementType === ElementType.Main) {
        targetRes = state.mapData.mainEles
      } else if (resource.elementType === ElementType.Obs) {
        targetRes = state.mapData.obsEles
      } else if (resource.elementType === ElementType.Custom) {
        targetRes = []
        state.mapData.customEles.forEach((item) => {
          item.customCategory.forEach((customCategory) => {
            targetRes.push(customCategory)
          })
        })
      }
      for (const i in targetRes) {
        const index = targetRes[i].resource.findIndex(
          (item) => item.id === resource.id,
        )
        if (index > -1) {
          targetRes[i].resource[index] = Object.assign(
            targetRes[i].resource[index],
            data,
          )
        }
      }
      state.mapData.editingResource = Object.assign(
        state.mapData.editingResource,
        data,
      )
      // 格子里的数据联动
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.element && item.element.resID === resource.id) {
            item.element = Object.assign(item.element, data)
          }
        })
      })
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    // 出口部分
    addExitCategory(state, value) {
      state.mapData.exitEles.push(value)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    deleteExitEleCategory(state, id) {
      const index = state.mapData.exitEles.findIndex((item) => item.id === id)
      if (state.mapData.exitEles[index].resource.length > 0) {
        // 一个分类下最多只有一个资源
        const resID = state.mapData.exitEles[index].resource[0].id
        state.mapData.renderData.forEach((rowItem) => {
          rowItem.forEach((item) => {
            if (item.exit && item.exit.resID === resID) {
              delete item.exit
            }
          })
        })
      }
      state.mapData.exitEles.splice(index, 1)
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateExitEnable(state, data) {
      const index = state.mapData.exitEles.findIndex(
        (item) => item.id === data.id,
      )
      state.mapData.exitEles[index].enable = data.enable
      if (!data.enable && state.mapData.exitEles[index].resource.length > 0) {
        // 一个分类下最多只有一个资源
        const resID = state.mapData.exitEles[index].resource[0].id
        state.mapData.renderData.forEach((rowItem) => {
          rowItem.forEach((item) => {
            if (item.exit && item.exit.resID === resID) {
              delete item.exit
            }
          })
        })
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    addExitEleResource(state, data) {
      const exitEle = state.mapData.exitEles.find(
        (item) => item.id === data.categoryId,
      )
      const obj = data.data
      obj.exitDir = exitEle.exitDir
      obj.bindMain = exitEle.bindMain
      exitEle.resource.push(obj)
      if (!state.mapData.resourceSelected) {
        state.mapData.resourceSelected = _.cloneDeep(obj)
        state.isSelectTool = true
        state.isEraseTool = false
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    deleteExitEleRes(state, id) {
      for (const i in state.mapData.exitEles) {
        const index = state.mapData.exitEles[i].resource.findIndex(
          (item) => item.id === id,
        )
        if (index > -1) {
          state.mapData.exitEles[i].resource.splice(index, 1)
          state.mapData.exitEles[i].bindMain = null
        }
      }
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.exit && item.exit.resID === id) {
            delete item.exit
          }
        })
      })
      state.mapData.selectedGrid = null
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateExitEleRes(state, data) {
      for (const i in state.mapData.exitEles) {
        const index = state.mapData.exitEles[i].resource.findIndex(
          (item) => item.id === data.id,
        )
        if (index > -1) {
          state.mapData.exitEles[i].resource[index] = Object.assign(
            state.mapData.exitEles[i].resource[index],
            data,
          )
        }
      }
      // 格子里的数据联动
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.exit && item.exit.resID === data.id) {
            if (data.url) {
              item.exit.url = data.url
              item.exit.resourceUrl = transform2bin(data.url)
            } else if (data.color) {
              item.exit.color = data.color
            }
          }
        })
      })
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateExitEleDir(state, data) {
      const exitEle = state.mapData.exitEles.find((item) => item.id === data.id)
      exitEle.exitDir = data.dir
      exitEle.resource.forEach((item) => {
        item.exitDir = data.dir
      })
      // 格子里的数据联动
      if (exitEle.resource.length > 0) {
        // 一个分类下最多只有一个资源
        const resID = exitEle.resource[0].id
        state.mapData.renderData.forEach((rowItem) => {
          rowItem.forEach((item) => {
            if (item.exit && item.exit.resID === resID) {
              item.exit.exitDir = data.dir
            }
          })
        })
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateExitEleBindMain(state, data) {
      const exitEle = state.mapData.exitEles.find((item) => item.id === data.id)
      exitEle.bindMain = data.mainEleId
      exitEle.resource.forEach((item) => {
        item.bindMain = data.mainEleId
      })
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateExitRotation(state, data) {
      const gridInfo = state.mapData.renderData[data.rowIndex][data.columnIndex]
      if (gridInfo.exit) {
        gridInfo.exit.rotation += data.rotation
        if (gridInfo.exit.rotation === 360 || gridInfo.exit.rotation === -360) {
          gridInfo.exit.rotation = 0
        }
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    deleteExit(state, data) {
      const gridInfo = state.mapData.renderData[data.rowIndex][data.columnIndex]
      if (gridInfo.exit) {
        delete gridInfo.exit
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    clearAllExitGrid(state) {
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.exit) {
            delete item.exit
          }
        })
      })
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    clearAllElement(state) {
      state.mapData.renderData.forEach((rowItem) => {
        rowItem.forEach((item) => {
          if (item.element) {
            delete item.element
          }
        })
      })
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    addAllGridRoad(state) {
      if (!state.mapData.resourceSelected) return
      state.mapData.renderData.forEach((rowItem, rowIndex) => {
        rowItem.forEach((item, columnIndex) => {
          if (state.mapData.isRoadArea) {
            state.mapData.renderData[rowIndex][columnIndex] = makeRoadAreaData(
              state.mapData.resourceSelected.id,
            )
          } else {
            state.mapData.renderData[rowIndex][columnIndex] = makeRoadImageData(
              state.mapData.resourceSelected.id,
              state.mapData.resourceSelected.url,
              state.mapData.resourceSelected.resourceUrl,
            )
          }
        })
      })
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    moveItemFinish(state) {
      const grid =
        state.mapData.renderData[state.mapData.movePosition.row][
          state.mapData.movePosition.column
        ]
      if (state.step === 2) {
        if (state.mapData.roadRule === RoadRule.EleOnRoad) {
          if (!grid.isRoad) {
            Message.error(i18n.t('workbench.park.step2Editor.nextWarning'))
            return
          }
        } else {
          if (grid.isRoad) {
            Message.error(i18n.t('workbench.park.step2Editor.nextWarning'))
            return
          }
        }
      }
      if (state.step === 1) {
        state.mapData.renderData[state.mapData.movePosition.row][
          state.mapData.movePosition.column
        ].isRoad = true
        state.mapData.renderData[state.mapData.movePosition.row][
          state.mapData.movePosition.column
        ].road = state.mapData.moveGrid
      } else if (state.step === 2) {
        state.mapData.renderData[state.mapData.movePosition.row][
          state.mapData.movePosition.column
        ].element = state.mapData.moveGrid
      } else if (state.step === 3) {
        state.mapData.renderData[state.mapData.movePosition.row][
          state.mapData.movePosition.column
        ].exit = state.mapData.moveGrid
      }
      state.mapData.movePosition = null
      state.mapData.moveGrid = null
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    updateMoveGridRotation(state, data) {
      state.mapData.moveGrid.rotation += data.rotation
      if (
        state.mapData.moveGrid.rotation === 360 ||
        state.mapData.moveGrid.rotation === -360
      ) {
        state.mapData.moveGrid.rotation = 0
      }
      state.mapData.moveGrid = _.cloneDeep(state.mapData.moveGrid)
      state.mapData.selectedGrid = {
        row: data.row,
        column: data.column,
      }
    },
  },

  actions: {
    initParkHistory({ state }) {
      state.historyList = []
      state.undoList = []
      const cloneData = _.cloneDeep(state.mapData)
      state.historyList.push(cloneData)
    },
    addHistory({ state }, data) {
      const cloneData = _.cloneDeep(data)
      state.historyList.push(cloneData)
      state.undoList = []
    },
    undoHistory({ state, commit }) {
      if (state.historyList.length <= 1) {
        return
      }
      const data = state.historyList.pop()
      state.undoList.push(data)
      const recoverData = state.historyList[state.historyList.length - 1]
      commit('updateMapData', _.cloneDeep(recoverData))
    },
    redoHistory({ state, commit }) {
      if (state.undoList.length === 0) {
        return
      }
      const data = state.undoList.pop()
      state.historyList.push(data)
      const recoverData = state.historyList[state.historyList.length - 1]
      commit('updateMapData', _.cloneDeep(recoverData))
    },
    addParkNode({ commit, state, dispatch, rootState }, { component }) {
      const currentScene =
        rootState.workspace.game.sceneManager.currentSceneNode
      const gridNode = gameIframe.qcGame.add.node()
      const editorData = editorScript.getScript(gridNode)
      editorData.$data.nodeType = nodeTypes.park
      gridNode.name = 'park'
      gridNode.width = 500
      gridNode.height = 500
      gridNode.addScript(component)
      currentScene.addChildAt(gridNode, currentScene.children.length)
      EventBus.$emit(Event.ADD_GAME_OBJECT, gridNode.uuid)
      dispatch(
        'workspace/game/updateActiveNode',
        { node: gridNode, record: false },
        {
          root: true,
        },
      )
      this.commit('workspace/game/updateFirstQuickLayoutTip', true)
    },
    clearRenderMapData({ state }) {
      state.mapData.renderData = []
      for (let i = 0; i < state.mapData.grid.row; i++) {
        const rowItem = []
        for (let j = 0; j < state.mapData.grid.column; j++) {
          const item = {}
          rowItem.push(item)
        }
        state.mapData.renderData.push(rowItem)
      }
    },
    readRenderMapDataFromScript({ state }) {
      const parkNode = getParkNode(state.sceneNode)
      const parkComponent = parkNode.getScript(scripts.park.name)
      const initValue = getInitState()
      state.mapData = initValue.mapData
      if (
        parkComponent.psConfig &&
        Object.keys(parkComponent.psConfig).length > 0
      ) {
        state.mapData = _.cloneDeep(parkComponent.psConfig)
      } else {
        this.dispatch('workspace/park/clearRenderMapData')
      }
    },
    emptyRenderMapData({ state }) {
      this.dispatch('workspace/park/clearRenderMapData')
      this.dispatch('workspace/park/addHistory', state.mapData)
    },
    moveItem({ state }, { dir }) {
      const grid =
        state.mapData.renderData[state.mapData.selectedGrid.row][
          state.mapData.selectedGrid.column
        ]
      if (dir === 'up') {
        if (state.mapData.selectedGrid.row - 1 < 0) {
          return
        }
        state.mapData.selectedGrid = {
          row: state.mapData.selectedGrid.row - 1,
          column: state.mapData.selectedGrid.column,
        }
        state.mapData.movePosition = {
          row: state.mapData.selectedGrid.row,
          column: state.mapData.selectedGrid.column,
        }
      } else if (dir === 'down') {
        if (state.mapData.selectedGrid.row + 1 >= state.mapData.grid.row) {
          return
        }
        state.mapData.selectedGrid = {
          row: state.mapData.selectedGrid.row + 1,
          column: state.mapData.selectedGrid.column,
        }
        state.mapData.movePosition = {
          row: state.mapData.selectedGrid.row,
          column: state.mapData.selectedGrid.column,
        }
      } else if (dir === 'left') {
        if (state.mapData.selectedGrid.column - 1 < 0) {
          return
        }
        state.mapData.selectedGrid = {
          row: state.mapData.selectedGrid.row,
          column: state.mapData.selectedGrid.column - 1,
        }
        state.mapData.movePosition = {
          row: state.mapData.selectedGrid.row,
          column: state.mapData.selectedGrid.column,
        }
      } else if (dir === 'right') {
        if (
          state.mapData.selectedGrid.column + 1 >=
          state.mapData.grid.column
        ) {
          return
        }
        state.mapData.selectedGrid = {
          row: state.mapData.selectedGrid.row,
          column: state.mapData.selectedGrid.column + 1,
        }
        state.mapData.movePosition = {
          row: state.mapData.selectedGrid.row,
          column: state.mapData.selectedGrid.column,
        }
      }
      if (state.step === 1) {
        if (!state.mapData.moveGrid) {
          state.mapData.moveGrid = _.cloneDeep(grid.road)
          delete grid.road
          delete grid.isRoad
          delete grid.element
          delete grid.exit
        }
      } else if (state.step === 2) {
        if (!state.mapData.moveGrid) {
          state.mapData.moveGrid = _.cloneDeep(grid.element)
          delete grid.element
        }
      } else if (state.step === 3) {
        if (!state.mapData.moveGrid) {
          state.mapData.moveGrid = _.cloneDeep(grid.exit)
          delete grid.exit
        }
      }
      state.mapData = _.cloneDeep(state.mapData)
    },
  },
}
